<template>
    <button
        @click="handleClick"
        :type="actionType"
        :data-uuid="settings.uuid"
        :id="settings.uuid"
        :style="buttonStyle"
        class="widget-button"
    >
        {{ settings.general.text }}
        <component :is="'style'">
            {{ childrenStyle }}
        </component>
    </button>
</template>

<script>
import { allEvents, resolveFont, resolveMargin, resolvePadding, toPx } from "../utils/style"
import ViewMixin from "../utils/view-mixin"

const APP_DOMAIN =
    window.app_domain === "kwiga.local"
        ? "http://kwiga.local"
        : window.app_domain === "kwiga3.link"
        ? "https://kwiga3.link"
        : "https://kwiga.com"

export default {
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    },
    mixins: [ViewMixin],
    name: "WidgetButton",
    methods: {
        async getCta(uuid) {
            const result = await fetch(`${APP_DOMAIN}/cta-settings/${uuid}`)
            const json = await result.json()
            return json
        },
        handleClick(event) {
            if (window.builder_dev_mode) {
                event.preventDefault()
                return
            }

            event.target?.dispatchEvent(new Event("widget-button-click"))

            if (this.action.type === "link") {
                window.open(this.action.payload.url, this.action.payload.target)
            }
        }
    },
    async mounted() {
        if (this.action.type === "widget" && !window.builder_dev_mode) {
            let cta = this.action.payload.refCta

            if (!cta) {
                return
            }

            const resultSettings = await this.getCta(cta.uuid)

            if (!resultSettings) {
                return
            }

            const { settings } = resultSettings

            if (!settings?.general?.modal?.isModal) {
                this.action.type = "link"
                this.action.payload.url = `${APP_DOMAIN}/landing/${cta.uuid}`
                this.action.payload.target = "_self"
                return
            }

            this.$el.setAttribute("data-widget-handler", cta.timestamp)

            const script = document.createElement("script")
            script.src = `${APP_DOMAIN}/build/js/kwiga-widget.js?t=${cta.timestamp}&uuid=${cta.uuid}${
                cta.is_modal ? "&is_modal=true" : ""
            }&producer=${APP_DOMAIN}/`

            script.type = "module"

            document.body.appendChild(script)
        }
    },
    computed: {
        childrenStyle() {
            let str = `
                #${this.settings.uuid}:hover {
                    background: ${this.general.hover} !important;
                }

            `
            if (this.general.hover === this.general.background) {
                str = `
                    #${this.settings.uuid}:hover {
                        filter: brightness(.9);
                    }
                `
            }

            str += `
                 #${this.settings.uuid}:active {
                    transform: scale(.99);
                }
            `

            return str
        },
        actionType() {
            if (this.action.type === "form") {
                return "submit"
            }
            return "button"
        },
        action() {
            return this.settings.action
        },
        desktop() {
            return this.settings.desktop
        },
        mobile() {
            return this.settings.mobile
        },
        general() {
            return this.settings.general
        },
        buttonStyle() {
            const { background, color, stretched, border } = this.general
            const style = {
                background,
                color,
                outline: "none",
                border: "none",
                cursor: "pointer",
                transition: ".2s",
                borderRadius: toPx(border.radius),
                borderWidth: toPx(border.width),
                ...allEvents(),
                ...this.resolveStyle(
                    {
                        width: toPx(this.desktop.width.value),
                        minWidth: toPx(this.desktop.width.value),
                        minHeight: toPx(this.desktop.height.value),
                        maxWidth: "100%",
                        ...resolveFont(this.desktop.font),
                        ...resolvePadding(this.desktop.padding),
                        ...resolveMargin(this.desktop.margin)
                    },
                    {
                        width: "100%",
                        maxWidth: toPx(this.mobile.width.value),
                        minHeight: toPx(this.mobile.height.value),
                        ...resolveFont(this.mobile.font),
                        ...resolvePadding(this.mobile.padding),
                        ...resolveMargin(this.mobile.margin)
                    }
                )
            }

            if (stretched) {
                style.width = "100%"
                style.maxWidth = "100%"
                style.minWidth = 0
            }

            if (this.general.style === "outline") {
                style.color = background
                style.borderColor = background
                style.borderStyle = "solid"
                style.background = "transparent"
            }

            return style
        }
    }
}
</script>
